import { render, staticRenderFns } from "./MonitoramentoSocioambiental.vue?vue&type=template&id=b95a70cc&lang=pug"
import script from "./MonitoramentoSocioambiental.vue?vue&type=script&lang=js"
export * from "./MonitoramentoSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./MonitoramentoSocioambiental.vue?vue&type=style&index=0&id=b95a70cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports